import { useContext } from "react";
import ReactPlayer from "react-player";
import { useNavigate } from "react-router-dom";

import {
  Avatar,
  Box,
  Card,
  CardMedia,
  Divider,
  Typography,
} from "@mui/material";

import { Verified } from "@mui/icons-material";

import ActionDrawer from "@/components/ActionDrawer";
import ImageCarousel from "@/components/ImageCarousel";
import NoteActions from "@/components/NoteActions";
import { SubscribedContext } from "@/providers/Subscribed";
import { renderTextWithMentions } from "@/utils/mentions";
import { formatDate } from "@/utils/time";

export default function FeedCard({ content }) {
  const navigate = useNavigate();
  const { isSubscribed, handleModalOpen } = useContext(SubscribedContext);

  return (
    <Box id={content.key} sx={{ my: 2 }}>
      <Box id="post-content-container" style={{ flex: 1 }}>
        <Box
          id="post-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            id="user-detail"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
            sx={{ p: 1 }}
            onClick={() => navigate("/" + content.owner.key)}
          >
            <Avatar
              src={content.owner.meta.profile}
              sx={{ width: 30, height: 30, marginRight: 1 }}
              onClick={() => navigate("/" + content.owner.key)}
            />
            <Typography
              variant="body"
              style={{ marginRight: "5px", fontWeight: "bold" }}
            >
              {content.owner.name}
            </Typography>

            {content.owner.role == "artist" && (
              <Verified
                color={content.owner.verified ? "secondary" : "disabled"}
                style={{ fontSize: "15px", marginRight: "5px" }}
              />
            )}
          </Box>

          <ActionDrawer content={content} />
        </Box>

        <MediaContentCard content={content} />

        <Box id="post-footer" sx={{ px: 1.5 }}>
          <NoteActions content={content} />
          <Box style={{ wordWrap: "break-all", whiteSpace: "pre-wrap" }}>
            <Typography variant="body" style={{ marginRight: "5px" }}>
              <span style={{ fontWeight: 600 }}>{content.owner.key} </span>

              {isSubscribed ? (
                renderTextWithMentions(content.meta.text)
              ) : (
                <Typography
                  variant="contained"
                  color="secondary"
                  sx={{ cursor: "pointer" }}
                  onClick={() => handleModalOpen()}
                >
                  subscribe to @{content.artist_key} to see caption
                </Typography>
              )}
            </Typography>
            {content.meta.tags && (
              <Typography variant="caption" style={{ color: "darkgray" }}>
                {content.meta.tags.join(", ")}
              </Typography>
            )}
          </Box>

          <Typography
            variant="caption"
            style={{ marginRight: "5px", color: "darkgray" }}
          >
            {formatDate(content.live)}
          </Typography>
        </Box>
        <Divider sx={{ mt: 2 }} />
      </Box>
    </Box>
  );
}

export function MediaContentCard({ content, setOpen }) {
  const contentType = content?.type || "";
  const contentURL = content?.meta?.url || "";

  const preventLongPressMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  return (
    <Box sx={{ mt: 1 }}>
      {["video"].includes(contentType) && (
        <Card style={{ borderRadius: "0px" }}>
          <ReactPlayer
            url={contentURL}
            light={content.meta.cover}
            // playing
            controls
            width="100%"
            height="400px"
            onContextMenu={preventLongPressMenu}
          />
        </Card>
      )}
      {["image"].includes(contentType) && (
        <Card style={{ borderRadius: "0px" }}>
          <CardMedia
            component="img"
            src={contentURL}
            onContextMenu={preventLongPressMenu}
            onTouchStart={preventLongPressMenu}
            onTouchEnd={preventLongPressMenu}
            onTouchMove={preventLongPressMenu}
            onMouseDown={preventLongPressMenu}
          />
        </Card>
      )}
      {["carousel"].includes(contentType) && (
        <Box style={{ borderRadius: "0px" }}>
          <ImageCarousel content={content} height={400} />
        </Box>
      )}
    </Box>
  );
}
